import { graphql, Link, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { usePageLocale } from '../../hooks/usePageLocale';
import { easeInOutSine, slideInAnim, slideOutAnim } from '../styles/animations';

const Wrapper = styled.nav`
  width: 100%;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  padding: 100px var(--padding) var(--gap-4) var(--padding);
  background: var(--blue-2);
  border-bottom: 4px solid var(--gold-2);
  display: ${({ $open }) => $open === null && 'none'};
  animation: ${({ $open }) => ($open ? slideInAnim : slideOutAnim)} 300ms
    ${easeInOutSine} forwards;

  @media screen and (min-width: 1121px) {
    display: none;
  }
`;

const List = styled.ul`
  display: grid;
  grid-auto-flow: row;
  list-style-type: none;
  height: min-content;
  width: 100%;
`;

const Item = styled.li`
  font-weight: 700;
  font-size: var(--font-size-3);
  width: 100%;
`;

const ItemLink = styled(Link)`
  color: white;
  padding: calc(var(--gap-6) + var(--gap-7)) 0;
  display: flex;
  justify-content: flex-end;
`;

const MailLink = styled.a`
  color: white;
  padding: calc(var(--gap-6) + var(--gap-7)) 0;
  display: flex;
  justify-content: flex-end;
`;

export const MobileMenu = ({ $open }) => {
  const { locale } = usePageLocale();
  const intl = useIntl();

  const data = useStaticQuery(graphql`
    {
      allDatoCmsHeaderMenu {
        nodes {
          nodeLocale: locale
          vociDelMenu {
            id: originalId
            voce
            slug
          }
        }
      }
    }
  `);

  const currentLocaleMenuNodes = data.allDatoCmsHeaderMenu.nodes.find(
    ({ nodeLocale }) => nodeLocale === locale
  );

  return (
    <Wrapper $open={$open}>
      <List>
        {currentLocaleMenuNodes.vociDelMenu.map(({ id, voce, slug }) => (
          <Item key={id}>
            <ItemLink activeClassName="menuActiveMobile" to={`/${slug}`}>
              {voce}
            </ItemLink>
          </Item>
        ))}
        <Item>
          <MailLink href="mailto:contattaci@larosadeigusti.com">
            {intl.formatMessage({ id: 'contact' })}
          </MailLink>
        </Item>
      </List>
    </Wrapper>
  );
};
